import RateDetailItemList, { RateDetailItemListProps } from './RateDetailItemList';

export type { RateDetailItemListProps };
export default RateDetailItemList;
